import script from "./MessageEmojiReactionsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageEmojiReactionsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./MessageEmojiReactionsPanel.vue?vue&type=style&index=0&id=e6274526&lang=scss"

const __exports__ = script;

export default __exports__